<select #selectEl [ngClass]="selectClass" multiple></select>
